import { Button } from '@mui/material';
import React, { Component } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // Import the CSS for the toasts
import errorImg from '../assets/images/no-data.gif'  

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false,error:null };
    }

    static getDerivedStateFromError(error) {
        // Update state to trigger fallback UI
        return { hasError: true,error };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error to an error reporting service or console
        console.error("Error caught by ErrorBoundary:", error, errorInfo);
        
    }
    componentDidUpdate(prevProps) {        
        // Reset the error boundary state when navigating to a different page
        if (prevProps.resetKey !== window.location.pathname && this.state.hasError) {
            window.location.reload();
        }
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className='error-boundary-container'>
                    <img src={errorImg} alt="" />
                    <h1>Something went wrong.</h1>
                    {/* <p>{this.state.error && this.state.error.toString()}</p> */}
                    <Button sx={{borderRadius:2}} onClick={()=>window.location.reload()} variant='contained' color='error'>Try again</Button>
                </div>)
        }
        return this.props.children;
    }
}

export default ErrorBoundary;